import { BadPressMatchRecord } from './../badpress-match.model';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { ConstantsService } from 'app/services/constants-service';
import { ObservableRequestService } from 'app/services/observable-request.service';
import { EntityType } from 'app/shared/models/entity-id-details.model';

// @todo: This file is still to be updated with Monitoring REST calls.

/**
 * Service for Monitoring bad press Information Details card.
 */
@Injectable()
export class BadPressService {

    constructor(private requestService: ObservableRequestService) { }

    getBadPressInfoDesc(entityId: number, entityType: EntityType): Observable<any> {
        const badPressInfoDescUri = ConstantsService.MONITORING_BAD_PRESS_MATCH_SERVICES + '/' + entityId;
        return this.requestService.getRequest(badPressInfoDescUri).map(response => {
            return response.arrResult || { suggestionList: [] };
        });
    };

    getBadPressInfoMatches(entityId: number, entityType: EntityType): Observable<any> {
        const badPressMatchDescUri = ConstantsService.MONITORING_BAD_PRESS_MATCH_SERVICES + '/' + entityId;
        return this.requestService.getRequest(badPressMatchDescUri).map(response => {
            return response.arrResult || { suggestionList: [] };
        });
    };

    getBadPressMatchDetail(entityId: number, badPressEntityId: number): Observable<any> {
        const uri = ConstantsService.MONITORING_BAD_PRESS_MATCH_SERVICES + '/' + entityId + '/match/' + badPressEntityId;
        return this.requestService.getRequest(uri).map(response => response.arrResult);
    };

    updateBadPressInfoDescription(badPressTextSaveData: BadPressMatchRecord, entityType: string): Observable<any> {
        const generalInfoSavePath = (entityType.toLocaleLowerCase() === 'person') ?
            ConstantsService.ENTITY_PERSON_GENERAL_INFO_SERVICES :
            ConstantsService.ENTITY_ORG_GENERAL_INFO_SERVICES;
        return this.requestService.putRequest(generalInfoSavePath,
            JSON.stringify(badPressTextSaveData),
            this.requestService.getJSONContentType());
    };

    markBadPressResolve(badPressMatchRecord: BadPressMatchRecord): Observable<any> {
        const badPressResolveURL = ConstantsService.RESOLVE_BAD_PRESS;
        return this.requestService.putRequest(badPressResolveURL,
            JSON.stringify(badPressMatchRecord),
            this.requestService.getJSONContentType());
    };
}



// WEBPACK FOOTER //
// ./src/app/entities/monitoring/actual/badpress/bad-press.service.ts